<mat-chip [disableRipple]="disableRipple" class="{{ color }}"><span class="mat-caption"> {{ label }}</span></mat-chip>
